import React, { useState } from 'react'
import Dialog from '../../components/Dialog'
import {
    Fade,
    TextField,
    Typography,
} from '@material-ui/core'
import useStyles from './styles'
import axios from 'axios'


export default function ForgotPasswordDialog(props) {
    var classes = useStyles()

    var [forgotPasswordEmail, setForgotPasswordEmail] = useState('')
    var [emailHasBeenSent, setEmailHasBeenSent] = useState(false)
    var [processingRequest, setProcessingRequest] = useState(false)
    var [emailError, setEmailError] = useState(false)
    var [emailErrorMessage, setEmailErrorMessage] = useState('')

    const forgotPassword = email => {
        if (processingRequest)
            return

        setProcessingRequest(true)
        let params = {
            email: email
        }
        axios.post('/api/forgotpassword', params).then(res => {
            console.log('Forgot Password', res)
            if (res.data.status) {
                setEmailHasBeenSent(true)
                setEmailError(false)
            } else {
                setEmailErrorMessage(res.data.message)
                setEmailError(true)
            }
            setProcessingRequest(false)
        }).catch(error => {
            setProcessingRequest(false)
            console.log(error)
        })
    }

    const closeDialog = () => {
        setEmailError(false)
        setEmailHasBeenSent(false)
        props.setDialogOpen(false)
    }

    return (
        <Dialog
            size={'sm'}
            title={'Forgot your password'}
            isOpen={props.dialogOpen}
            actions={!emailHasBeenSent ? [
                {
                    title: 'Submit',
                    func: () => forgotPassword(forgotPasswordEmail)
                },
            ] : [{
                title: 'Close',
                func: () => closeDialog()
            }]}
            onClose={() => closeDialog()}>
            {!emailHasBeenSent ?
                <div>
                    <Fade in={emailError}>
                        <Typography
                            color="secondary"
                            className={classes.errorMessage}
                        >
                            {emailErrorMessage}
                        </Typography>
                    </Fade>
                    <TextField
                        id="email"
                        InputProps={{
                            classes: {
                                underline: classes.textFieldUnderline,
                                input: classes.textField,
                            },
                        }}
                        value={forgotPasswordEmail}
                        onChange={e => setForgotPasswordEmail(e.target.value)}
                        margin="normal"
                        placeholder="Email Address"
                        type="email"
                        fullWidth
                    />
                </div> : <h3 className={classes.forgotEmailSuccessMessage}>Email has been sent</h3>}
        </Dialog>
    )
}